<template>
  <SecondaryModal
    :name="$options.name"
    :title="$t('post.delete')"
    @before-open="reset"
  >
    <div v-if="post" v-html="$t('deleteConfirmation', { name: text })"></div>

    <template v-slot:footer>
      <BaseButton oval secondary @click="$modal.hide($options.name)">{{ $t('buttonCancel') }}</BaseButton>
      <BaseButton oval red :loading="loading" @click="deleteRequest">{{ $t('buttonDelete') }}</BaseButton>
    </template>
  </SecondaryModal>
</template>

<script>
import SecondaryModal from './SecondaryModal'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'delete-social-post',
  components: {
    SecondaryModal
  },
  data () {
    return {
      loading: false,
      postId: null
    }
  },
  computed: {
    ...mapGetters({
      getPost: 'entities/socialPosts/getPost'
    }),
    post () {
      return this.getPost(this.postId)
    },
    text () {
      if (!this.post) return
      if (this.post.text.length < 20) return this.post.text
      return this.post.text.slice(0, 20) + '...'
    }
  },
  methods: {
    reset ({ params: { postId } }) {
      this.loading = false
      this.postId = postId
    },
    ...mapActions({
      deletePost: 'entities/socialPosts/deletePost'
    }),
    async deleteRequest () {
      this.loading = true
      try {
        await this.deletePost(this.postId)
      } catch (e) {
        this.$modal.show('error', {
          error: e.response.data
        })
      } finally {
        this.loading = false
        this.$modal.hide(this.$options.name)
      }
    }
  }
}
</script>

<style module lang="scss">

</style>
